<template>
    <DCard
        padding
    >
        <CompensationRateForm
            :errors="errors"
            @form-submitted="storeCompensationRate"
        />
    </DCard>
</template>

<script>
import CompensationRateForm from '~@/Components/Tools/Partners/CompensationRates/Form'

export default {
    name: 'CompensationRateCreate',
    components: {
        CompensationRateForm
    },
    props: {
        errors: {
            type: Object,
            default: () => { return {} }
        }
    },
    methods: {
        storeCompensationRate (form) {
            form.post(this.$route('tools.partners.partner-compensation-rates.store'))
        }
    }
}
</script>

<style scoped>

</style>
